import { List } from '@chakra-ui/react'
import React, { FC } from 'react'

interface IHeaderPopoverListProps {
  children?: React.ReactNode
}

/**
 * List for the popover in the header menu.
 *
 * Should use the `HeaderPopoverListItem` as children or any other component
 * at your convenience.
 */
export const HeaderPopoverList: FC<IHeaderPopoverListProps> = ({ children }) => (
  <List data-testid="header-popover-list" spacing={1}>
    {children}
  </List>
)
